import { render, staticRenderFns } from "./ContactListPage.vue?vue&type=template&id=1b8d5c1e&"
import script from "./ContactListPage.vue?vue&type=script&lang=js&"
export * from "./ContactListPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactListPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports